import { styled, TableContainer } from "@mui/material";
// Styled components for responsive behavior
export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
    "& .MuiTable-root": {
        tableLayout: "fixed",
    },
    "& .MuiTableHead-root": {
        [theme.breakpoints.down("sm")]: {
            display: "none",
        },
    },
    "& .MuiTableRow-root": {
        border: `1px solid ${theme.palette.divider}`,
        [theme.breakpoints.down("sm")]: {
            border: `1px solid ${theme.palette.divider}`,
            display: "block",
            marginBottom: theme.spacing(1),
            borderRadius: theme.shape.borderRadius,
        },
    },
    "& .MuiTableCell-root": {
        textAlign: "left",
        border: "none",
        [theme.breakpoints.down("sm")]: {
            border: "none",
            borderBottom: `1px solid ${theme.palette.divider}`,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            textAlign: "right",
            "&.MuiTableCell-alignRight": {
                //Fix for right-aligned columns on mobile
                flexDirection: "row",
            },
            "&:before": {
                content: "attr(data-label)",
                fontWeight: "bold",
                textTransform: "uppercase",
                textAlign: "left",
            },
            "&:last-child": {
                borderBottom: 0,
            },
            "&.no-data-cell": {
                display: "table-cell",
                textAlign: "center",
                "&:before": {
                    content: "none",
                },
            },
        },
    },
}));
